import { DefaultLookUpSuccessResponse } from '../model/common-service.interface';

export const CommonServiceMocks = {
  removeDeepLinkVendorCookie: {}
};

export const DefaultLookUpSuccessResponseMock: DefaultLookUpSuccessResponse = {
  lookupId: 'DEFAULT',
  tripType: {
    default: '{"key":"rt"}',
    Name: 'tripType',
    Values: [
      {
        key: 'rt',
        value: 'ROUND_TRIP'
      },
      {
        key: 'ow',
        value: 'ONE_WAY'
      },
      {
        key: 'mc',
        value: 'MULTI_CITY'
      }
    ]
  },
  passengers: {
    default: '{"key":"3Passenger"}',
    Name: 'passengers',
    Values: [
      {
        key: '1 Passenger'
      },
      {
        key: '2 Passenger'
      },
      {
        key: '3 Passenger'
      }
    ]
  },
  request: {
    default: '',
    Name: 'request',
    Values: [
      {
        pageName: 'ADV_SEARCH'
      }
    ]
  },
  defaultMap: {
    flexCheck: false,
    flexairportsearch: false,
    refundableFlightsOnly: false,
    calendarsearch: false,
    deltaAndPartners: true,
    nonstopFlightsOnly: false
  },
  disableBestFares: false,
  disableEdocLink: false,
  disableFlexibleDates: false,
  disableMeetingCode: false,
  disableNearbyAirport: false,
  disablePaxDropDown: false,
  disableRefundableFares: false,
  disableShowPriceIn: false,
  disableTripType: false,
  edocDefaultPaxCount: 0,
  edocMaxPaxCount: 0,
  edocMinPaxCount: 0,
  edocSearch: 0,
  fareBrandsByMiles: {
    default: '',
    Name: 'fareBrandsByMiles',
    Values: [
      {
        brandID: 'BE',
        brandName: 'Basic Economy'
      },
      {
        brandID: 'MAIN',
        brandName: 'Main Cabin'
      },
      {
        brandID: 'DCP',
        brandName: 'Delta Comfort+'
      },
      {
        brandID: 'FIRST',
        brandName: 'First Class'
      },
      {
        brandID: 'DPPS',
        brandName: 'Premium Select'
      },
      {
        brandID: 'D1',
        brandName: 'Delta One'
      }
    ]
  },
  fareBrandsByMoney: {
    default: '',
    Name: 'fareBrandsByMoney',
    Values: [
      {
        brandID: 'BE',
        brandName: 'Basic Economy'
      },
      {
        brandID: 'MAIN',
        brandName: 'Main Cabin'
      },
      {
        brandID: 'DCP',
        brandName: 'Delta Comfort+'
      },
      {
        brandID: 'FIRST',
        brandName: 'First Class'
      },
      {
        brandID: 'DPPS',
        brandName: 'Premium Select'
      },
      {
        brandID: 'D1',
        brandName: 'Delta One'
      }
    ]
  },
  flexOptions: {
    default: 'FLEX_DAYS',
    Name: 'flexOptions',
    Values: [
      {
        value: 'FLEX_DAYS',
        isDefaulted: 'true'
      },
      {
        value: 'WEEKS',
        isDefaulted: 'false'
      }
    ]
  },
  journeyTypeOptions: {
    default: '',
    Name: 'journeyTypeOptions',
    Values: [
      {
        value: 'ROUND_TRIP',
        isDefaulted: 'true'
      },
      {
        value: 'ONE_WAY',
        isDefaulted: 'false'
      },
      {
        value: 'MULTICITY',
        isDefaulted: 'false'
      }
    ]
  },
  meetingEventSearch: false,
  paxDefaults: {
    default: '',
    Name: 'paxDefaults',
    Values: [
      {
        paxCode: 'ADT',
        paxDesc: 'Adult',
        defaultCount: '1',
        maximumPaxCount: '9'
      }
    ]
  },
  RadiusDefaults: {
    default: '',
    Name: 'RadiusDefaults',
    Values: [
      {
        unit: 'MI',
        measure: '0',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '25',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '50',
        value: 'Miles',
        isDefaulted: 'false'
      },
      {
        unit: 'MI',
        measure: '100',
        value: 'Miles',
        isDefaulted: 'true'
      }
    ]
  },
  shopTypeOptions: {
    default: '',
    Name: 'shopTypeOptions',
    Values: [
      {
        value: 'MONEY',
        isDefaulted: 'true'
      },
      {
        value: 'MILES',
        isDefaulted: 'false'
      }
    ]
  },
  useEdocDefaultPaxCount: false,
  sessionTimeoutLimit: 30,
  sessionTimeoutModelLimit: 15
};

export const DefaultLookUpErrorResponseMock = {
  code: 'string',
  message: 'string',
  developerMessage: 'string',
  moreInfo: [
    {
      code: 'string',
      field: 'string',
      message: 'string'
    }
  ]
};
